module.exports = __webpack_public_path__ + "5c735ba6928cb86d5865018c7f717306.MP3";